import { HabitSchedule } from '@griply/types';

import { getScheduleFrequencyDayTarget } from './get-schedule-frequency-day-target';

// A frequency outrunning its period (10x per week) has no per-day slice: the count is the target.
export const getScheduleDayTarget = (schedule: HabitSchedule): number =>
  schedule.frequency
    ? getScheduleFrequencyDayTarget(schedule) ?? schedule.frequency.count
    : schedule.completionTarget.count;
